// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './nubekeyboard.es-AR.json';
import esMX from './nubekeyboard.es-MX.json';
import ptBR from './nubekeyboard.pt-BR.json';

const nubekeyBoardTranslations: DomainTranslations = {
  name: 'nubekeyboard',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
  },
};

export default nubekeyBoardTranslations;
